import { trackError } from '@billy/track-error'
import { useCallback } from 'react'

import { getGlobalBilly } from '../../utils/globalBilly'

export const useEmberTransitionTo = () => {
  const transitionTo = useCallback((url: string, ...args: any) => {
    try {
      const billyApp = getGlobalBilly()
      const emberRouter = billyApp?.__container__?.lookup('router:main')
      emberRouter.transitionTo(url, ...args)
    } catch (error) {
      trackError(error)
    }
  }, [])

  const replaceWith = useCallback((url: string, ...args: any) => {
    try {
      const billyApp = getGlobalBilly()
      const emberRouter = billyApp?.__container__?.lookup('router:main')
      emberRouter.replaceWith(url, ...args)
    } catch (error) {
      trackError(error)
    }
  }, [])

  return {
    replaceWith,
    transitionTo,
  }
}
